import rgba from '../../utils/rgba';
export default (context => ({
  button: {
    fontFamily: context.font.bodyFontFamily,
    fontWeight: 'bold',
    textTransform: 'none',
    borderRadius: '3px',
    borderWidth: context.input.borderWidth,
    // uses input values where possible to align the button heights and input heights
    fontSize: context.font.baseFontSize,
    lineHeight: context.input.lineHeight,
    padding: "".concat(context.input.vPadding, " 26px"),
    smallFontSize: context.font.smallFontSize,
    smallLineHeight: context.input.smallLineHeight,
    smallPadding: "".concat(context.input.smallVPadding, " 20px"),
    largeFontSize: context.font.h5FontSize,
    largeLineHeight: context.font.h5LineHeight,
    largePadding: '17px 40px',
    miniFontSize: context.font.smallFontSize,
    miniLineHeight: context.font.smallLineHeight,
    miniPadding: '3px 10px'
  },
  colour: {
    button: context.colour.secondary,
    buttonBorder: 'transparent',
    buttonText: context.colour.white,
    buttonHover: context.colour.secondaryDark,
    buttonHoverBorder: 'transparent',
    buttonHoverText: context.colour.white,
    buttonDisabled: context.colour.neutral300,
    buttonDisabledText: context.colour.white,
    // Note: in Domain there's no established style for "secondary" buttons, so it just looks like the primary one
    buttonMuted: context.colour.neutral200,
    buttonMutedBorder: 'transparent',
    buttonMutedText: context.colour.neutral600,
    buttonMutedHover: context.colour.neutral300,
    buttonMutedHoverBorder: 'transparent',
    buttonMutedHoverText: context.colour.neutral600,
    buttonMutedActive: context.colour.neutral800,
    buttonMutedActiveText: context.colour.neutral800Text,
    buttonMutedActiveBorder: 'transparent',
    buttonHighlight: context.colour.accent,
    buttonHighlightBorder: 'transparent',
    buttonHighlightText: context.colour.accentText,
    buttonHighlightHover: context.colour.accentDark,
    buttonHighlightHoverBorder: 'transparent',
    buttonHighlightHoverText: context.colour.accentDarkText,
    buttonHighlightActive: context.colour.accent,
    buttonOutlineBorder: context.colour.neutral800,
    buttonOutlineText: context.colour.neutral700,
    buttonOutlineHoverBorder: context.colour.neutral800,
    buttonOutlineHover: rgba(context.colour.neutral300, 0.3),
    buttonOutlineHoverText: context.colour.neutral700,
    buttonOutlineActive: rgba(context.colour.neutral300, 0.3),
    buttonOutlineActiveText: context.colour.neutral700,
    buttonOutlineActiveBorder: context.colour.neutral800,
    buttonOutlineDisabledBorder: context.colour.neutral300,
    buttonOutlineDisabledText: context.colour.neutral300,
    buttonGhostBorder: context.colour.white,
    buttonGhostText: context.colour.neutral50,
    buttonGhostHover: rgba(context.colour.white, 0.2),
    buttonGhostHoverBorder: context.colour.white,
    buttonGhostHoverText: context.colour.neutral50,
    buttonGhostDisabledBorder: rgba(context.colour.white, 0.4),
    buttonGhostDisabledText: context.colour.neutral400,
    buttonLowlight: rgba(context.colour.neutral600, 0.9),
    buttonLowlightBorder: 'transparent',
    buttonLowlightText: context.colour.neutral600Text,
    buttonLowlightHover: context.colour.neutral600,
    buttonLowlightHoverBorder: 'transparent',
    buttonLowlightHoverText: context.colour.neutral600Text
  }
}));